import { render } from "./InternalGraphPopup3d.vue?vue&type=template&id=7a5e4582"
import script from "./InternalGraphPopup3d.vue?vue&type=script&lang=js"
export * from "./InternalGraphPopup3d.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__